module.exports = __webpack_public_path__ + "static/media/favoriteTreat-discount.d627d620.jpg";